"use client";

import React from "react";

import { useUI } from "@/components/ui/context";

interface MobileMenuViewProps {
	title: string;
	children: React.ReactNode;
}

const MobileMenuView = ({ title, children }: MobileMenuViewProps) => {
	const { setPageTitle, setMenuView } = useUI();

	React.useEffect(() => {
		setPageTitle(title);
		setMenuView(children);
	}, [setPageTitle, children, setMenuView, title]);

	return children;
};

export { MobileMenuView };
